// Configurazione React Query client
import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Considera i dati freschi per 30 secondi
      staleTime: 30 * 1000,
      // Cache per 5 minuti
      gcTime: 5 * 60 * 1000,
      // Riprova una volta in caso di errore
      retry: 1,
      // Non rifetching al focus finestra (evita chiamate eccessive)
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
